import axios from "axios"

export async function get(url, config = {}) {
  return await axios.get(url, { ...config }).then(response => response.data)
}
export async function postFormData(url, data, config = {}) {
  return axios
    .post(url, data, { ...config })
    .then(response => response.data)
}
export async function post(url, data, config = {}) {
 
  return axios
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function postAdapter(url, data = null, params = null, config = {}) {
  const axiosConfig = {
    ...config,
    ...(params && { params }),
  };

  return axios
    .post(url, data, axiosConfig)
    .then(response => response.data)
    
}


export async function put(url, data, config = {}) {
  return axios
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axios
    .delete(url, { ...config })
    .then(response => response.data)
}

export async function download(url, config = {}, type = 'blob') {
  return await axios.get( url,{
    responseType: type,
    ...config
  })
  .then(response => response.data)
}
